import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { TitleHomeV2Variant } from "./types";
import { motion } from "framer-motion";

type Props = React.HTMLProps<HTMLDivElement> & {
  variant: TitleHomeV2Variant;
};

export const TitleHomeV2 = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, variant, ...rest } = props;
  const classNameVariant: Record<TitleHomeV2Variant, string> = {
    [TitleHomeV2Variant.H1]:
      "text-dark-purple-50 text-[48px] -tracking-wider leading-[50px] text-center md:text-[96px] md:leading-[95px] lg:text-left lg:text-[80px] lg:leading-[88px]",
    [TitleHomeV2Variant.H2]:
      "text-dark-purple-50 text-2xl md:text-4xl -tracking-wider md:leading-[42px] lg:text-5xl ",
    [TitleHomeV2Variant.H3]:
      "text-dark-purple-50 text-[20px] leading-[24px] xl:text-[24px] xl:leading-[32px] -tracking-wide",
    [TitleHomeV2Variant.H4]:
      "text-dark-purple-50 text-[20px] xl:text-[24px] xl:leading-[35px] leading-[25px] font-bold",
    [TitleHomeV2Variant.BODY1]:
      "text-dark-purple-50 text-lg md:text-xl lg:text-2xl",
    [TitleHomeV2Variant.BODY2]:
      "text-dark-purple-50 text-base md:text-lg lg:text-xl",
    [TitleHomeV2Variant.BODY3]:
      "text-dark-purple-50 text-sm md:text-base lg:text-lg",
    [TitleHomeV2Variant.BODY4]:
      "text-dark-purple-50 text-xs md:text-sm lg:text-base",
    [TitleHomeV2Variant.SUBTITLE1]:
      "text-dark-purple-50 text-sm md:text-base tracking-[4px] md:tracking-[6px] font-bold",
    [TitleHomeV2Variant.SUBTITLE2]:
      "text-dark-purple-50 text-sm md:text-base font-bold",
  };

  const classNameFromVariant = classNameVariant[variant];

  return (
    <div
      className={twMerge(classNameFromVariant, className)}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
});

export const MotionTitleHomeV2 = motion(TitleHomeV2);
